import { BookOpen, Database, FileBarChart, FileText, Globe, ImagePlus, MessageSquare, MessagesSquare, Radio, Search, Table, Users, Workflow } from '@digital-twins/design-system/icons'
import { STUDY_GOAL_ICONS } from './studyGoalIcons'

/** Entity identity stays the same while the separate status glyph changes. */
export const ENTITY_ICONS = {
  library: BookOpen, social: Radio, audience: Users, study: FileBarChart,
  run: FileBarChart, room: MessagesSquare, thread: MessageSquare, web: Globe,
  dataset: Table, connector_record: Database, image: ImagePlus, workflow: Workflow,
  report: FileText, research: Search,
} as const
export type EntityIconKind = keyof typeof ENTITY_ICONS

export function studyEntityIcon(goalId?: string | null) {
  return goalId && Object.hasOwn(STUDY_GOAL_ICONS, goalId)
    ? STUDY_GOAL_ICONS[goalId as keyof typeof STUDY_GOAL_ICONS] : ENTITY_ICONS.study
}
